import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { default as SmtpAccountInformation, } from './SmtpAccountInformation';
var styles = require('./OutgoingServerInformation.scss');
var OutgoingServerInformation = /** @class */ (function (_super) {
    tslib_1.__extends(OutgoingServerInformation, _super);
    function OutgoingServerInformation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OutgoingServerInformation.prototype.render = function () {
        return (this.props.isRemoteSend() && (React.createElement("div", null,
            React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_edit_smtpServerTextField, onChanged: this.props.onUpdateOutgoingServer, value: this.props.outgoingServer }),
            React.createElement(TextField, { className: styles.textbox, label: strings.options_connected_edit_smtpPortTextField, onChanged: this.props.onUpdateOutgoingPort, value: this.props.outgoingPort }),
            !this.props.isSendOnly() &&
                this.props.isBasicAuth && (React.createElement(SmtpAccountInformation, tslib_1.__assign({}, this.props.smtpAccountInformationProps))))));
    };
    OutgoingServerInformation = tslib_1.__decorate([
        observer
    ], OutgoingServerInformation);
    return OutgoingServerInformation;
}(React.Component));
export default OutgoingServerInformation;
//# sourceMappingURL=OutgoingServerInformation.js.map